module.exports = __webpack_public_path__ + "static/banner-dd064b4991d4ad760a5f17ff96f9f0e1.jpg";